export const data = [
    {
        "Continent_Name": "Europe",
        "Zone_Id": "AT",
        "Country_Name": "Austria",
        "Zone_Name": "Austria",
        "AWS_Region": "",
        "Azure_Region": "Austria East",
        "GCP_Region": "",
        "azure_pue": "1.12",
        "azure_renewable": "1",
        "azure_wue": "0.023",
        "aws_pue": "",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "",
        "carbon_intensity": 92.46385542168674,
        "fossil_fuel_percentage": 13.869277108433733
    },
    {
        "Continent_Name": "Australia",
        "Zone_Id": "AUS-NSW",
        "Country_Name": "Australia",
        "Zone_Name": "New South Wales",
        "AWS_Region": "ap-southeast-2",
        "Azure_Region": "",
        "GCP_Region": "australia-southeast1",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "1.2",
        "gcp_cfe": "0.21",
        "gcp_carbon_intensity": "598",
        "carbon_intensity": 536.1736526946107,
        "fossil_fuel_percentage": 64.09868263473051
    },
    {
        "Continent_Name": "Europe",
        "Zone_Id": "BE",
        "Country_Name": "Belgium",
        "Zone_Name": "Belgium",
        "AWS_Region": "",
        "Azure_Region": "",
        "GCP_Region": "europe-west1",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "",
        "gcp_cfe": "0.68",
        "gcp_carbon_intensity": "110",
        "carbon_intensity": 129.4550898203593,
        "fossil_fuel_percentage": 21.083652694610787
    },
    {
        "Continent_Name": "Asia",
        "Zone_Id": "BH",
        "Country_Name": "Bahrain",
        "Zone_Name": "Bahrain",
        "AWS_Region": "me-south-1",
        "Azure_Region": "",
        "GCP_Region": "",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "1.2",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "",
        "carbon_intensity": 0.0,
        "fossil_fuel_percentage": 0.0
    },
    {
        "Continent_Name": "South America",
        "Zone_Id": "BR-CS",
        "Country_Name": "Brazil",
        "Zone_Name": "Central Brazil",
        "AWS_Region": "",
        "Azure_Region": "",
        "GCP_Region": "southamerica-east1",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "",
        "gcp_cfe": "0.78",
        "gcp_carbon_intensity": "129",
        "carbon_intensity": 103.23493975903614,
        "fossil_fuel_percentage": 11.616506024096378
    },
    {
        "Continent_Name": "South America",
        "Zone_Id": "BR-S",
        "Country_Name": "Brazil",
        "Zone_Name": "South Brazil",
        "AWS_Region": "sa-east-1",
        "Azure_Region": "Brazil South",
        "GCP_Region": "",
        "azure_pue": "1.12",
        "azure_renewable": "0.06",
        "azure_wue": "0.039",
        "aws_pue": "1.2",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "",
        "carbon_intensity": 66.7125748502994,
        "fossil_fuel_percentage": 6.217125748502997
    },
    {
        "Continent_Name": "North America",
        "Zone_Id": "CA-ON",
        "Country_Name": "Canada",
        "Zone_Name": "Ontario",
        "AWS_Region": "",
        "Azure_Region": "",
        "GCP_Region": "northamerica-northeast2",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "",
        "gcp_cfe": "0.92",
        "gcp_carbon_intensity": "29",
        "carbon_intensity": 70.8443113772455,
        "fossil_fuel_percentage": 12.499281437125736
    },
    {
        "Continent_Name": "North America",
        "Zone_Id": "CA-QC",
        "Country_Name": "Canada",
        "Zone_Name": "Qu\u00e9bec",
        "AWS_Region": "ca-central-1",
        "Azure_Region": "",
        "GCP_Region": "northamerica-northeast1",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "1.2",
        "gcp_cfe": "1",
        "gcp_carbon_intensity": "0",
        "carbon_intensity": 31.868263473053894,
        "fossil_fuel_percentage": 0.36826347305389223
    },
    {
        "Continent_Name": "Europe",
        "Zone_Id": "CH",
        "Country_Name": "Switzerland",
        "Zone_Name": "Switzerland",
        "AWS_Region": "eu-central-2",
        "Azure_Region": "",
        "GCP_Region": "europe-west6",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "86",
        "carbon_intensity": 75.86826347305389,
        "fossil_fuel_percentage": 7.5083233532934095
    },
    {
        "Continent_Name": "South America",
        "Zone_Id": "CL-SEN",
        "Country_Name": "Chile",
        "Zone_Name": "Sistema El\u00e9ctrico Nacional",
        "AWS_Region": "",
        "Azure_Region": "Chile Central",
        "GCP_Region": "southamerica-west1",
        "azure_pue": "1.12",
        "azure_renewable": "0.2",
        "azure_wue": "0.02",
        "aws_pue": "",
        "gcp_cfe": "0.69",
        "gcp_carbon_intensity": "190",
        "carbon_intensity": 126.53892215568862,
        "fossil_fuel_percentage": 25.631736526946113
    },
    {
        "Continent_Name": "Asia",
        "Zone_Id": "CN",
        "Country_Name": "China",
        "Zone_Name": "China",
        "AWS_Region": "cn-north-1",
        "Azure_Region": "",
        "GCP_Region": "",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "1.2",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "",
        "carbon_intensity": 0.0,
        "fossil_fuel_percentage": 0.0
    },
    {
        "Continent_Name": "Europe",
        "Zone_Id": "DE",
        "Country_Name": "Germany",
        "Zone_Name": "Germany",
        "AWS_Region": "eu-central-1",
        "Azure_Region": "",
        "GCP_Region": "europe-west3",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "1.2",
        "gcp_cfe": "0.61",
        "gcp_carbon_intensity": "269",
        "carbon_intensity": 481.83233532934133,
        "fossil_fuel_percentage": 44.58431137724552
    },
    {
        "Continent_Name": "Europe",
        "Zone_Id": "DK-DK2",
        "Country_Name": "Denmark",
        "Zone_Name": "East Denmark",
        "AWS_Region": "",
        "Azure_Region": "Denmark East",
        "GCP_Region": "",
        "azure_pue": "1.16",
        "azure_renewable": "1",
        "azure_wue": "0.01",
        "aws_pue": "",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "",
        "carbon_intensity": 205.4311377245509,
        "fossil_fuel_percentage": 15.953532934131749
    },
    {
        "Continent_Name": "Europe",
        "Zone_Id": "ES",
        "Country_Name": "Spain",
        "Zone_Name": "Spain",
        "AWS_Region": "eu-south-2",
        "Azure_Region": "Spain Central",
        "GCP_Region": "europe-southwest1",
        "azure_pue": "1.12",
        "azure_renewable": "",
        "azure_wue": "0.06",
        "aws_pue": "",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "121",
        "carbon_intensity": 190.1437125748503,
        "fossil_fuel_percentage": 31.545029940119758
    },
    {
        "Continent_Name": "Europe",
        "Zone_Id": "FI",
        "Country_Name": "Finland",
        "Zone_Name": "Finland",
        "AWS_Region": "",
        "Azure_Region": "Finland Central",
        "GCP_Region": "europe-north1",
        "azure_pue": "1.12",
        "azure_renewable": "1",
        "azure_wue": "0.01",
        "aws_pue": "",
        "gcp_cfe": "0.91",
        "gcp_carbon_intensity": "127",
        "carbon_intensity": 48.83832335329341,
        "fossil_fuel_percentage": 4.562574850299404
    },
    {
        "Continent_Name": "Europe",
        "Zone_Id": "FR",
        "Country_Name": "France",
        "Zone_Name": "France",
        "AWS_Region": "eu-west-3",
        "Azure_Region": "",
        "GCP_Region": "europe-west9",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "1.2",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "59",
        "carbon_intensity": 33.383233532934135,
        "fossil_fuel_percentage": 4.143832335329343
    },
    {
        "Continent_Name": "Europe",
        "Zone_Id": "GB",
        "Country_Name": "Great Britain",
        "Zone_Name": "Great Britain",
        "AWS_Region": "eu-west-2",
        "Azure_Region": "",
        "GCP_Region": "europe-west2",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "1.2",
        "gcp_cfe": "0.54",
        "gcp_carbon_intensity": "172",
        "carbon_intensity": 286.50299401197606,
        "fossil_fuel_percentage": 47.828922155688616
    },
    {
        "Continent_Name": "Europe",
        "Zone_Id": "GB-NIR",
        "Country_Name": "Northern Ireland",
        "Zone_Name": "Northern Ireland",
        "AWS_Region": "eu-west-1",
        "Azure_Region": "",
        "GCP_Region": "",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "1.2",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "",
        "carbon_intensity": 286.50299401197606,
        "fossil_fuel_percentage": 47.828922155688616
    },
    {
        "Continent_Name": "North America",
        "Zone_Id": "GE",
        "Country_Name": "USA",
        "Zone_Name": "Georgia",
        "AWS_Region": "",
        "Azure_Region": "East US 3",
        "GCP_Region": "",
        "azure_pue": "1.12",
        "azure_renewable": "",
        "azure_wue": "0.06",
        "aws_pue": "",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "",
        "carbon_intensity": 240.11976047904193,
        "fossil_fuel_percentage": 42.654191616766454
    },
    {
        "Continent_Name": "Europe",
        "Zone_Id": "GR",
        "Country_Name": "Greece",
        "Zone_Name": "Greece",
        "AWS_Region": "",
        "Azure_Region": "Greece Central",
        "GCP_Region": "",
        "azure_pue": "1.12",
        "azure_renewable": "",
        "azure_wue": "0.102",
        "aws_pue": "",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "",
        "carbon_intensity": 414.32335329341316,
        "fossil_fuel_percentage": 57.03508982035926
    },
    {
        "Continent_Name": "Asia",
        "Zone_Id": "HK",
        "Country_Name": "Hong Kong",
        "Zone_Name": "Hong Kong",
        "AWS_Region": "ap-east-1",
        "Azure_Region": "",
        "GCP_Region": "asia-east2",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "1.2",
        "gcp_cfe": "0.28",
        "gcp_carbon_intensity": "360",
        "carbon_intensity": 435.0,
        "fossil_fuel_percentage": 72.0
    },
    {
        "Continent_Name": "Asia",
        "Zone_Id": "ID",
        "Country_Name": "Indonesia",
        "Zone_Name": "Indonesia",
        "AWS_Region": "ap-southeast-3",
        "Azure_Region": "Indonesia Central",
        "GCP_Region": "asia-southeast2",
        "azure_pue": "1.32",
        "azure_renewable": "",
        "azure_wue": "1.9",
        "aws_pue": "",
        "gcp_cfe": "0.13",
        "gcp_carbon_intensity": "580",
        "carbon_intensity": 682,
        "fossil_fuel_percentage": 60.6112
    },
    {
        "Continent_Name": "Europe",
        "Zone_Id": "IE",
        "Country_Name": "Ireland",
        "Zone_Name": "Ireland",
        "AWS_Region": "",
        "Azure_Region": "North Europe",
        "GCP_Region": "",
        "azure_pue": "1.22",
        "azure_renewable": "0.49",
        "azure_wue": "0.03",
        "aws_pue": "",
        "gcp_cfe": "0.42",
        "gcp_carbon_intensity": "",
        "carbon_intensity": 378.7065868263473,
        "fossil_fuel_percentage": 63.23185628742509
    },
    {
        "Continent_Name": "Asia",
        "Zone_Id": "IN-DL",
        "Country_Name": "India",
        "Zone_Name": "Delhi",
        "AWS_Region": "",
        "Azure_Region": "South India",
        "GCP_Region": "asia-south2",
        "azure_pue": "1.43",
        "azure_renewable": "0.16",
        "azure_wue": "0",
        "aws_pue": "",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "671",
        "carbon_intensity": 442.4702380952381,
        "fossil_fuel_percentage": 85.4000595238095
    },
    {
        "Continent_Name": "Asia",
        "Zone_Id": "IN-MH",
        "Country_Name": "India",
        "Zone_Name": "Maharashtra",
        "AWS_Region": "ap-south-1",
        "Azure_Region": "South India",
        "GCP_Region": "asia-south1",
        "azure_pue": "1.43",
        "azure_renewable": "0.16",
        "azure_wue": "0",
        "aws_pue": "1.2",
        "gcp_cfe": "0.1",
        "gcp_carbon_intensity": "670",
        "carbon_intensity": 718.4821428571429,
        "fossil_fuel_percentage": 88.56404761904757
    },
    {
        "Continent_Name": "Asia",
        "Zone_Id": "JP-KN",
        "Country_Name": "Japan",
        "Zone_Name": "Kansai",
        "AWS_Region": "ap-northeast-3",
        "Azure_Region": "",
        "GCP_Region": "asia-northeast2",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "1.2",
        "gcp_cfe": "0.31",
        "gcp_carbon_intensity": "384",
        "carbon_intensity": 456.58682634730536,
        "fossil_fuel_percentage": 70.69838323353291
    },
    {
        "Continent_Name": "Asia",
        "Zone_Id": "JP-TK",
        "Country_Name": "Japan",
        "Zone_Name": "T\u014dky\u014d",
        "AWS_Region": "ap-northeast-1",
        "Azure_Region": "",
        "GCP_Region": "asia-northeast1",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "1.2",
        "gcp_cfe": "0.16",
        "gcp_carbon_intensity": "464",
        "carbon_intensity": 560.1137724550898,
        "fossil_fuel_percentage": 85.13263473053892
    },
    {
        "Continent_Name": "Asia",
        "Zone_Id": "KR",
        "Country_Name": "South Korea",
        "Zone_Name": "South Korea",
        "AWS_Region": "ap-northeast-2",
        "Azure_Region": "Korea Central",
        "GCP_Region": "asia-northeast3",
        "azure_pue": "1.12",
        "azure_renewable": "0.11",
        "azure_wue": "0.34",
        "aws_pue": "1.2",
        "gcp_cfe": "0.31",
        "gcp_carbon_intensity": "425",
        "carbon_intensity": 488.2634730538922,
        "fossil_fuel_percentage": 69.28616766467074
    },
    {
        "Continent_Name": "North America",
        "Zone_Id": "MX",
        "Country_Name": "Mexico",
        "Zone_Name": "Mexico",
        "AWS_Region": "",
        "Azure_Region": "Mexico Central",
        "GCP_Region": "",
        "azure_pue": "1.12",
        "azure_renewable": "",
        "azure_wue": "0.056",
        "aws_pue": "",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "",
        "carbon_intensity": 0.0,
        "fossil_fuel_percentage": 0.0
    },
    {
        "Continent_Name": "Europe",
        "Zone_Id": "NL",
        "Country_Name": "Netherlands",
        "Zone_Name": "Netherlands",
        "AWS_Region": "",
        "Azure_Region": "West Europe",
        "GCP_Region": "europe-west4",
        "azure_pue": "1.16",
        "azure_renewable": "0.91",
        "azure_wue": "0.08",
        "aws_pue": "",
        "gcp_cfe": "0.61",
        "gcp_carbon_intensity": "283",
        "carbon_intensity": 334.13253012048193,
        "fossil_fuel_percentage": 51.971385542168676
    },
    {
        "Continent_Name": "Australia",
        "Zone_Id": "NZ",
        "Country_Name": "New Zealand",
        "Zone_Name": "New Zealand",
        "AWS_Region": "",
        "Azure_Region": "New Zealand North",
        "GCP_Region": "",
        "azure_pue": "1.12",
        "azure_renewable": "0.34",
        "azure_wue": "0",
        "aws_pue": "",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "",
        "carbon_intensity": 133.22289156626505,
        "fossil_fuel_percentage": 16.156385542168668
    },
    {
        "Continent_Name": "Europe",
        "Zone_Id": "PL",
        "Country_Name": "Poland",
        "Zone_Name": "Poland",
        "AWS_Region": "",
        "Azure_Region": "Poland Central",
        "GCP_Region": "europe-central2",
        "azure_pue": "1.12",
        "azure_renewable": "",
        "azure_wue": "0.023",
        "aws_pue": "",
        "gcp_cfe": "0.2",
        "gcp_carbon_intensity": "576",
        "carbon_intensity": 813.6084337349398,
        "fossil_fuel_percentage": 73.79168674698799
    },
    {
        "Continent_Name": "Europe",
        "Zone_Id": "SE",
        "Country_Name": "Sweden",
        "Zone_Name": "Sweden",
        "AWS_Region": "eu-north-1",
        "Azure_Region": "Sweden Central",
        "GCP_Region": "",
        "azure_pue": "1.21",
        "azure_renewable": "",
        "azure_wue": "0.14",
        "aws_pue": "1.2",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "",
        "carbon_intensity": 15.970059880239521,
        "fossil_fuel_percentage": 0.05898203592814363
    },
    {
        "Continent_Name": "Asia",
        "Zone_Id": "SG",
        "Country_Name": "Singapore",
        "Zone_Name": "Singapore",
        "AWS_Region": "ap-southeast-1",
        "Azure_Region": "South East Asia",
        "GCP_Region": "asia-southeast1",
        "azure_pue": "1.364",
        "azure_renewable": "0.16",
        "azure_wue": "1.97",
        "aws_pue": "1.2",
        "gcp_cfe": "0.04",
        "gcp_carbon_intensity": "372",
        "carbon_intensity": 485.01197604790417,
        "fossil_fuel_percentage": 96.0064071856287
    },
    {
        "Continent_Name": "Asia",
        "Zone_Id": "TW",
        "Country_Name": "Taiwan",
        "Zone_Name": "Taiwan",
        "AWS_Region": "",
        "Azure_Region": "Taiwan north",
        "GCP_Region": "asia-east1",
        "azure_pue": "1.2",
        "azure_renewable": "",
        "azure_wue": "1",
        "aws_pue": "",
        "gcp_cfe": "0.17",
        "gcp_carbon_intensity": "456",
        "carbon_intensity": 532.7964071856287,
        "fossil_fuel_percentage": 82.76395209580835
    },
    {
        "Continent_Name": "North America",
        "Zone_Id": "US-CAL-CISO",
        "Country_Name": "USA",
        "Zone_Name": "California Independent System Operator",
        "AWS_Region": "us-west-1",
        "Azure_Region": "West US",
        "GCP_Region": "",
        "azure_pue": "1.21",
        "azure_renewable": "0.55",
        "azure_wue": "0",
        "aws_pue": "1.2",
        "gcp_cfe": "0.55",
        "gcp_carbon_intensity": "",
        "carbon_intensity": 248.04790419161677,
        "fossil_fuel_percentage": 43.35664670658682
    },
    {
        "Continent_Name": "North America",
        "Zone_Id": "US-CAL-LDWP",
        "Country_Name": "USA",
        "Zone_Name": "Los Angeles Department Of Water And Power",
        "AWS_Region": "",
        "Azure_Region": "",
        "GCP_Region": "us-west2",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "190",
        "carbon_intensity": 521.827380952381,
        "fossil_fuel_percentage": 79.68845238095238
    },
    {
        "Continent_Name": "North America",
        "Zone_Id": "US-CAR-SC",
        "Country_Name": "USA",
        "Zone_Name": "South Carolina Public Service Authority",
        "AWS_Region": "",
        "Azure_Region": "",
        "GCP_Region": "us-east1",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "",
        "gcp_cfe": "0.19",
        "gcp_carbon_intensity": "434",
        "carbon_intensity": 828.8869047619048,
        "fossil_fuel_percentage": 82.31476190476191
    },
    {
        "Continent_Name": "North America",
        "Zone_Id": "US-CAR-SCEG",
        "Country_Name": "USA",
        "Zone_Name": "South Carolina Electric & Gas Company",
        "AWS_Region": "",
        "Azure_Region": "",
        "GCP_Region": "us-east1",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "434",
        "carbon_intensity": 398.47305389221555,
        "fossil_fuel_percentage": 67.24694610778444
    },
    {
        "Continent_Name": "North America",
        "Zone_Id": "US-MIDA-PJM",
        "Country_Name": "USA",
        "Zone_Name": "PJM Interconnection, Llc",
        "AWS_Region": "us-east-1",
        "Azure_Region": "East US",
        "GCP_Region": "us-east4",
        "azure_pue": "1.18",
        "azure_renewable": "0.8",
        "azure_wue": "0.18",
        "aws_pue": "1.2",
        "gcp_cfe": "0.41",
        "gcp_carbon_intensity": "309",
        "carbon_intensity": 381.0542168674699,
        "fossil_fuel_percentage": 59.99289156626505
    },
    {
        "Continent_Name": "North America",
        "Zone_Id": "US-MIDA-PJM",
        "Country_Name": "USA",
        "Zone_Name": "PJM Interconnection, Llc",
        "AWS_Region": "us-east-2",
        "Azure_Region": "",
        "GCP_Region": "",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "1.2",
        "gcp_cfe": null,
        "gcp_carbon_intensity": null,
        "carbon_intensity": 381.0542168674699,
        "fossil_fuel_percentage": 59.99289156626505
    },
    {
        "Continent_Name": "North America",
        "Zone_Id": "US-MIDW-MISO",
        "Country_Name": "USA",
        "Zone_Name": "Midcontinent Independent Transmission System Operator Inc.",
        "AWS_Region": "",
        "Azure_Region": "Central US",
        "GCP_Region": "us-central1",
        "azure_pue": "1.169",
        "azure_renewable": "0.68",
        "azure_wue": "0.28",
        "aws_pue": "",
        "gcp_cfe": "0.78",
        "gcp_carbon_intensity": "394",
        "carbon_intensity": 583.1024096385543,
        "fossil_fuel_percentage": 76.05132530120481
    },
    {
        "Continent_Name": "North America",
        "Zone_Id": "US-NW-BPAT",
        "Country_Name": "USA",
        "Zone_Name": "Bonneville Power Administration",
        "AWS_Region": "us-west-2",
        "Azure_Region": "",
        "GCP_Region": "us-west1",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "1.2",
        "gcp_cfe": "0.89",
        "gcp_carbon_intensity": "60",
        "carbon_intensity": 92.46385542168674,
        "fossil_fuel_percentage": 13.869277108433733
    },
    {
        "Continent_Name": "North America",
        "Zone_Id": "US-NW-GCPD",
        "Country_Name": "USA",
        "Zone_Name": "PUD No. 2 Of Grant County Washington",
        "AWS_Region": "",
        "Azure_Region": "West US 2",
        "GCP_Region": "",
        "azure_pue": "1.16",
        "azure_renewable": "0.55",
        "azure_wue": "0.97",
        "aws_pue": "",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "",
        "carbon_intensity": 24.0,
        "fossil_fuel_percentage": 0.0
    },
    {
        "Continent_Name": "North America",
        "Zone_Id": "US-NW-NEVP",
        "Country_Name": "USA",
        "Zone_Name": "Nevada Power Company",
        "AWS_Region": "",
        "Azure_Region": "",
        "GCP_Region": "us-west4",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "",
        "gcp_cfe": "0.13",
        "gcp_carbon_intensity": "365",
        "carbon_intensity": 500.9030303030303,
        "fossil_fuel_percentage": 84.2362424242424
    },
    {
        "Continent_Name": "North America",
        "Zone_Id": "US-NW-PACE",
        "Country_Name": "USA",
        "Zone_Name": "Pacificorp East",
        "AWS_Region": "",
        "Azure_Region": "West Central US",
        "GCP_Region": "us-west3",
        "azure_pue": "1.117",
        "azure_renewable": "0.55",
        "azure_wue": "0.25",
        "aws_pue": "",
        "gcp_cfe": "0.25",
        "gcp_carbon_intensity": "448",
        "carbon_intensity": 779.5575757575757,
        "fossil_fuel_percentage": 84.07739393939397
    },
    {
        "Continent_Name": "North America",
        "Zone_Id": "US-SW-AZPS",
        "Country_Name": "USA",
        "Zone_Name": "Arizona Public Service Company",
        "AWS_Region": "",
        "Azure_Region": "West US 3",
        "GCP_Region": "",
        "azure_pue": "1.593",
        "azure_renewable": "0.55",
        "azure_wue": "2.69",
        "aws_pue": "",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "",
        "carbon_intensity": 677.5212121212121,
        "fossil_fuel_percentage": 90.93715151515151
    },
    {
        "Continent_Name": "North America",
        "Zone_Id": "US-TEX-ERCO",
        "Country_Name": "USA",
        "Zone_Name": "Electric Reliability Council Of Texas Inc.",
        "AWS_Region": "",
        "Azure_Region": "South Central US",
        "GCP_Region": "us-south1",
        "azure_pue": "1.36",
        "azure_renewable": "0.8",
        "azure_wue": "1.9",
        "aws_pue": "",
        "gcp_cfe": "0.4",
        "gcp_carbon_intensity": "296",
        "carbon_intensity": 481.29940119760477,
        "fossil_fuel_percentage": 74.37670658682629
    },
    {
        "Continent_Name": "Africa",
        "Zone_Id": "ZA",
        "Country_Name": "South Africa",
        "Zone_Name": "South Africa",
        "AWS_Region": "af-south-1",
        "Azure_Region": "",
        "GCP_Region": "",
        "azure_pue": "",
        "azure_renewable": "",
        "azure_wue": "",
        "aws_pue": "1.2",
        "gcp_cfe": "",
        "gcp_carbon_intensity": "",
        "carbon_intensity": 694.8614457831326,
        "fossil_fuel_percentage": 85.09975903614455
    },
    // {
    //     "Continent_Name": "Asia",
    //     "Zone_Id": "AE",
    //     "Country_Name": "United Arab Emirates",
    //     "Zone_Name": "United Arab Emirates",
    //     "AWS_Region": "me-central-1",
    //     "Azure_Region": "",
    //     "GCP_Region": "",
    //     "azure_pue": "",
    //     "azure_renewable": "",
    //     "azure_wue": "",
    //     "aws_pue": "1.2",
    //     "gcp_cfe": "",
    //     "gcp_carbon_intensity": null
    // },
    // {
    //     "Continent_Name": "Australia",
    //     "Zone_Id": "AU-VIC",
    //     "Country_Name": "Australia",
    //     "Zone_Name": "Victoria",
    //     "AWS_Region": "ap-southeast-4",
    //     "Azure_Region": "",
    //     "GCP_Region": "",
    //     "azure_pue": "",
    //     "azure_renewable": "",
    //     "azure_wue": "",
    //     "aws_pue": "1.2",
    //     "gcp_cfe": null,
    //     "gcp_carbon_intensity": null
    // },
    // {
    //     "Continent_Name": "Asia",
    //     "Zone_Id": "IL",
    //     "Country_Name": "Israel",
    //     "Zone_Name": "Israel",
    //     "AWS_Region": "il-central-1",
    //     "Azure_Region": "",
    //     "GCP_Region": "",
    //     "azure_pue": "",
    //     "azure_renewable": "",
    //     "azure_wue": "",
    //     "aws_pue": "1.2",
    //     "gcp_cfe": null,
    //     "gcp_carbon_intensity": null
    // },
    // {
    //     "Continent_Name": "Asia",
    //     "Zone_Id": "IN-SO",
    //     "Country_Name": "India",
    //     "Zone_Name": "Southern",
    //     "AWS_Region": "ap-south-2",
    //     "Azure_Region": "",
    //     "GCP_Region": "",
    //     "azure_pue": "",
    //     "azure_renewable": "",
    //     "azure_wue": "",
    //     "aws_pue": "1.2",
    //     "gcp_cfe": null,
    //     "gcp_carbon_intensity": null
    // },
    // {
    //     "Continent_Name": "Europe",
    //     "Zone_Id": "IT-NO",
    //     "Country_Name": "Italy",
    //     "Zone_Name": "North",
    //     "AWS_Region": "eu-south-1",
    //     "Azure_Region": "Italy North",
    //     "GCP_Region": "europe-west8",
    //     "azure_pue": "1.12",
    //     "azure_renewable": "",
    //     "azure_wue": "0.023",
    //     "aws_pue": "1.2",
    //     "gcp_cfe": "",
    //     "gcp_carbon_intensity": "298"
    // },
]